import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  shopClearOrderForOrganization,
  shopClearOrderOnBehalfUser,
  shopSetOrderForOrganization,
  shopSetOrderOnBehalfPendingUserSelection,
} from '../../store/actions';
import { Flex, Gutter, Loader } from '@gaiads/telia-react-component-library';
import { useParams, Redirect } from 'react-router';

const ShopLoader = () => {
  const dispatch = useDispatch();
  const { orderType } = useParams<{ orderType: string }>();
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (orderType === 'ownOrder') {
      dispatch(shopClearOrderForOrganization());
      dispatch(shopClearOrderOnBehalfUser());
      setRedirect(true);
    } else if (orderType === 'orderForOrganization') {
      dispatch(shopClearOrderOnBehalfUser());
      dispatch(shopSetOrderForOrganization());
      setRedirect(true);
    } else if (orderType === 'orderForUser') {
      dispatch(shopClearOrderForOrganization());
      dispatch(shopClearOrderOnBehalfUser());
      dispatch(shopSetOrderOnBehalfPendingUserSelection());
      setRedirect(true);
    }
  }, [dispatch, orderType]);

  if (redirect) {
    return <Redirect to="/shop" />;
  }

  return (
    <>
      <Gutter size="xlg" />
      <Flex centered>
        <Loader />
      </Flex>
    </>
  );
};

export default ShopLoader;
